import React, { useState } from 'react';
import { connect } from 'react-redux';
import InternalContainer from '../../layout/containers/Internal';
import PolicyList from '../components/PolicyList/PolicyList';
import { get } from 'lodash';
import getIncludedResource from '../../../helpers/getIncludedResource';
import { Tab, Tabs } from 'react-bootstrap';

const ORDER = [
  'Leisure Travel Insurance',
  'Personal Accident Insurance',
  'Baggage Insurance',
];

const DISPLAY_NAME_OVERRIDE = {
  'Baggage Insurance': 'Smart Luggage',
};
const PolicyListContainer = ({ auth }) => {
  const [activeTab, setActiveTab] = useState(0);

  const currentBroker = get(auth, 'user.data.relationships.current_broker.data.id', null);

  const products = getIncludedResource(
    auth.user.data,
    auth.user.included,
    'available_products',
  );

  const productsByType = products.reduce((carry, product) => {
    const productType = product.attributes.product_type;
    if (carry[productType]) {
      carry[productType].push(product);
      return carry;
    }
    carry[productType] = [product];
    return carry;
  }, {});

  const productTypes = Object.keys(productsByType);
  const sortedProductTypes = productTypes.sort((productTypeA, productTypeB) => {
    if (ORDER.indexOf(productTypeA) < ORDER.indexOf(productTypeB)) {
      return -1;
    }
  });

  const handleTab = (key) => {
    setActiveTab(key);
  };

  return (
    <InternalContainer title="Policies">
      <Tabs
        activeKey={activeTab}
        id="broker"
        justified
        unmountOnExit={true}
        onSelect={handleTab}
      >
        {sortedProductTypes.map((type, index) => {
          const products = productsByType[type];
          const productIds = products.map((product) => product.id);
          const displayName = DISPLAY_NAME_OVERRIDE?.[type] ?? type;
          return (
            <Tab key={type} eventKey={index} title={displayName}>
              <PolicyList
                key={type}
                sourceKey={type}
                filters={[
                  {
                    type: 'filter[product]',
                    value: productIds.join(','),
                  },
                ]}
                currentBroker={currentBroker}
              />
            </Tab>
          );
        })}
      </Tabs>
    </InternalContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(PolicyListContainer);
